var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.colors),function(item,i){return _c('div',{key:i,staticClass:"d-block",style:(`height: 80px; background: ${item}`)},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }